/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// STRUCTURE : SUBHEAD : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	subhead: {
		background: theme.color.supporting.dark.swatch,
		color: theme.color.supporting.dark.contrast,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		// height: pxToEm(94),
		width: '100%',
		padding: replacePXinStringWithEM(`32px ${theme.spacing.sides}`),
		transition: theme.animation.general('all'),
		'& h1': {
			fontSize: pxToEm(26),
			fontWeight: 'normal'
		},

		// animation
		opacity: '0',
		animationName: 'fadeInRight',
		animationDelay: '.1s',
		animationDuration: '.2s',
		animationFillMode: 'forwards',

		// used on embeds and reports to show unique embed name or report name
		'& .uniquename': {
			color: theme.color.primary.medium.swatch,
			fontSize: '65%',
            paddingRight: pxToEm(10),

			opacity: '0',
			animationName: 'fadeInLeft',
			animationDelay: '1.1s', // this will be custom per section depending on the animation timing of that sections contents (for example, embeds will have a much longer delay than reports)
			animationDuration: '.2s',
			animationFillMode: 'forwards'
		},
		'& .ctas': {
            '& .link': {
                color: theme.color.supporting.light.swatch,
                opacity: '0',
                animationName: 'fadeInRight',
                animationDelay: '1.1s', // will be section dependant just like uniquename
                animationDuration: '.2s',
                animationFillMode: 'forwards'
            }
        }
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: { 
		subhead: {
			// height: pxToEm(70),
			paddingTop: pxToEm(23),
			paddingBottom: pxToEm(23),
			'& h1': {
				fontSize: pxToEm(20)
			},
			'& .ctas': {
				'& .button, .link': {
					fontSize: pxToEm(13)
				}
			}
		}
	}
});